import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TenantService } from '../../services/tenant/tenant.service';
import { AUTH_ROUTES } from '../../constants/auth.routing.constants';
import { AppStorage } from '../../enums/app-storage';
import { RoleTypes } from '../../constants/role-types.constant';
import { CookieService } from '../../services/cookie/cookie.service';

export const adminAuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const tenantService = inject(TenantService);
  const cookieService = inject(CookieService);

  const isTokenPresent = !!cookieService.get(AppStorage.token);
  const role = cookieService.get(AppStorage.role);

  const parsedRole = role ? JSON.parse(role) : null;
  const hasAdminRoleInArray = parsedRole
    ? parsedRole.includes(RoleTypes.SUPER_ADMIN) ||
      parsedRole.includes(RoleTypes.ADMIN)
    : false;
  const hasAdminRoleInObject =
    parsedRole?.name === RoleTypes.SUPER_ADMIN ||
    parsedRole?.name === RoleTypes.ADMIN;
  const hasMatchingRole = Array.isArray(parsedRole)
    ? hasAdminRoleInArray
    : hasAdminRoleInObject;
  const isRoleAdmin = parsedRole ? hasMatchingRole : false;
  const isVendor = parsedRole
    ? Array.isArray(parsedRole)
      ? parsedRole.includes(RoleTypes.VENDOR)
      : parsedRole.name === RoleTypes.VENDOR
    : false;

  if (!isTokenPresent) {
    const queryParamArray = location.search.replace('?', '').split('=');
    const queryParamObject = { [queryParamArray[0]]: queryParamArray[1] };

    return router.createUrlTree([tenantService.authPath(AUTH_ROUTES.LOGIN)], {
      queryParams: {
        target: location.pathname,
        ...queryParamObject,
      },
    });
  }

  if (isTokenPresent && !isRoleAdmin) {
    if (isVendor) {
      router.navigate([tenantService.vendorPath()]);
    } else {
      router.navigate([tenantService.tenantPath('')]);
    }
  }

  return isTokenPresent && isRoleAdmin;
};
